import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import AccountUser from "./AccountUser";
import { setAccountId } from "./concerns/SetAccountId";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    author_account_user_id: {
      type: "string",
    },
    body: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    directory_ai_reason: {
      type: "string",
    },
    directory_moderation_status: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["club_message_directory_status"],
    },
    is_archived: {
      type: "boolean",
    },
    is_deleted: {
      type: "boolean",
    },
    public_in_directory: {
      type: "boolean",
    },
    published_ends_at: {
      type: "datetime",
    },
    published_starts_at: {
      type: "datetime",
    },
    title: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    author: reference(() => AccountUser, "author_account_user_id"),
  },
);

interface ClubMessage extends ModelAttributes<typeof config> {}

@setAccountId
@model("club_messages", config)
class ClubMessage extends Model<typeof config> {}

export default ClubMessage;
